export default __webpack_public_path__ + "images/icons/youtube-557dbcb0198cef3ebd12b05e9615ef33.svg";